import { Modal, Descriptions, Tooltip } from 'antd'
import { FileTextOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import ProductListTable from '../../../components/ProductListTable'
import useBillType from '../hooks/useStockBillType'
import useBillTypeContext from '../hooks/useStockBillTypeContext'
import useGetBillProductList from '../hooks/useGetBillProductList'
import { inventoryTypeMap, typeMap, inventoryTypeEnum } from '../config'
import moment from 'moment'
import service from "../../../@services";

const colorStyle = { color: '#FA4B54' }
const basicDescs = [
  {
    title: '经手人',
    key: 'operName'
  },
  {
    title: '单据状态',
    key: 'status'
  }
]
const endBasicDescs = [
  {
    title: '备注',
    key: 'note'
  }
]
export default function BillDetail({ id, title, onClose: _onClose }) {
  const { type, baseQueryModule } = useBillTypeContext()
  const typeText = inventoryTypeMap[type]
  const middleList = [
    {
      title: (type == inventoryTypeEnum.In ? '库存' : typeText) + '类型',
      key: 'type'
    },
    {
      title: typeText + '方式',
      key: 'wayType'
    },
    {
      title: typeText + '时间',
      key: 'createTime',
      formate: val => {
        return moment(val).format('YYYY-MM-DD HH:mm:SS')
      }
    }
  ]
  const [billDetail, setBillDetail] = useState({
    kindTotal: 0,
    sheet: {},
    stockTotal: 0,
    totalAmount: 0
  })
  const [storeId, setStoreId] = useState('');
  const [showDetail, setShowDetail] = useState(false)
  const { pageData, loading, getList } = useGetBillProductList()
  const {
    billSheet,
    isPurchase,
    isPurchaseReturnOut,
    stockType,
    baseTypeText
  } = useMemo(() => {
    const stockType = billDetail.sheet.type || ''
    return {
      billSheet: billDetail.sheet,
      isPurchase: stockType.indexOf('PURCHAGE') > -1,
      isPurchaseReturnOut: stockType === 'PURCHAGE_CANCEL',
      stockType,
      baseTypeText:
        stockType &&
        typeMap[stockType] &&
        inventoryTypeMap[typeMap[stockType].type]
    }
  }, [billDetail.sheet])
  const descriptionTitle = (
    <>
      <FileTextOutlined />
      <span style={{ marginLeft: '8px' }}>
        {baseTypeText}
        单号：{billSheet.no}
      </span>
    </>
  )
  const onClose = () => {
    setShowDetail(false)
    _onClose()
  }
  const typeTextMap = useBillType(billSheet)
  const getDetailByReq = async id => {
    setShowDetail(true)
    const _detail = await baseQueryModule.getStockDetail(id)
    const _storeList = await service.common.getStoreList()
    const index = _storeList.findIndex(item=> item.storeCode == _detail.sheet.storeCode);
    if (index > -1){
      setStoreId(_storeList[index].id)
    }
    _detail && setBillDetail(_detail)
  }
  useEffect(() => {
    if (id) {
      getDetailByReq(id)
      getList({ billNo: id })
    }
  }, [id])

  const { orderOtherColumns } = useMemo(
    () => ({
      orderOtherColumns: [
        {
          title: '数量',
          dataIndex: 'stock'
        },
        {
          title: (
            <Tooltip title={typeTextMap.costTitleTips[1]}>
              <div>
                <span style={{ marginRight: '6px' }}>
                  {typeTextMap.costTitleTips[0]}
                </span>
                <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
              </div>
            </Tooltip>
          ),
          dataIndex: 'cost'
        },
        {
          title:  typeTextMap.amountTitle,
          dataIndex: 'costTotal'
        }
      ]
    }),
    [typeTextMap]
  )
  const { returnOtherColumns } = useMemo(
    () => ({
      returnOtherColumns: [
        {
          title: '数量',
          dataIndex: 'stock'
        },
        {
          title: (
            <Tooltip title={typeTextMap.costTitleTips[1]}>
              <div>
                <span style={{ marginRight: '6px' }}>
                  {typeTextMap.costTitleTips[0]}
                </span>
                <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
              </div>
            </Tooltip>
          ),
          dataIndex:
            billSheet.type == 'PURCHAGE_CANCEL' ? 'refCostPrice' : 'cost'
        },
        {
          title: '退货单价（元）',
          dataIndex: 'cost'
        },
        {
          title: '退款金额（元）',
          dataIndex: 'costTotal'
        }
      ]
    }),
    [typeTextMap, billSheet]
  )
  return (
    <Modal
      title={baseTypeText + '详情'}
      visible={showDetail}
      footer={null}
      width={860}
      onCancel={onClose}>
      {!!id && (
        <Descriptions title={descriptionTitle}>
          {isPurchase && (
            <Descriptions.Item label='所属供应商'>
              {billSheet.supplierName}
            </Descriptions.Item>
          )}
          {basicDescs.map((item, index) => (
            <Descriptions.Item key={index + item.key} label={item.title}>
              {typeTextMap[item.key] || billSheet[item.key]}
            </Descriptions.Item>
          ))}
          {/* 售后单号或者订单编号是只有销售和退货才展示 或者盘点 */}
          {stockType.indexOf('SALE') > -1 && (
            <Descriptions.Item
              labelStyle={{ color: '#1890ff' }}
              contentStyle={{ color: '#1890ff' }}
              label={(stockType.indexOf('OK') > -1 ? '订单' : '售后') + '编号'}>
              {stockType.indexOf('OK') > -1 ?
                <Link style={{ color: '#1890ff' }} to={{pathname:'/order/list', query: {orderNo: billSheet.thirdNo}}}>{billSheet.thirdNo}</Link>
                :
                <Link style={{ color: '#1890ff' }} to={{pathname:'/after-sale/list', query: {aftersaleNo: billSheet.thirdNo}}}>{billSheet.thirdNo}</Link>
              }
            </Descriptions.Item>
          )}
          {stockType.indexOf('PURCHAGE_OK') > -1 && (
            <Descriptions.Item
              labelStyle={{ color: '#1890ff' }}
              contentStyle={{ color: '#1890ff' }}
              label="采购单">
              <Link style={{ color: '#1890ff' }} to={{pathname:'/purchase-order', query: {purchaseOrderNo: billSheet.thirdNo, activeKey: billSheet.thirdNo.indexOf('CGPU') == 0? 1:2}}}>{billSheet.thirdNo}</Link>
            </Descriptions.Item>
          )}
          {stockType.indexOf('PURCHAGE_CANCEL') > -1 && (
            <Descriptions.Item
              labelStyle={{ color: '#1890ff' }}
              contentStyle={{ color: '#1890ff' }}
              label="采购单">
              <Link style={{ color: '#1890ff' }} to={{pathname:'/purchase-order', query: {purchaseOrderNo: billSheet.thirdNo, activeKey: billSheet.thirdNo.indexOf('CGPU') == 0? 1:2}}}>{billSheet.thirdNo}</Link>
            </Descriptions.Item>
          )}

          {stockType.indexOf('CHECK') > -1 && (
            <Descriptions.Item
              labelStyle={{ color: '#1890ff' }}
              contentStyle={{ color: '#1890ff' }}
              label='盘点单号'>
              <Link style={{ color: '#1890ff' }} to={{pathname:'/inventory/check-sheet/list', query: {checkNo: billSheet.thirdNo}}}>{billSheet.thirdNo}</Link>
            </Descriptions.Item>
          )}
          {['ALLOCATION_OUT', 'ALLOCATION_IN'].includes(stockType) && (
            <Descriptions.Item
              labelStyle={{ color: '#1890ff' }}
              contentStyle={{ color: '#1890ff' }}
              label='调拨单号'>
              <Link style={{ color: '#1890ff' }} to={{pathname:'/inventory/allocation', query: {no: billSheet.thirdNo, activeKey: stockType == 'ALLOCATION_IN'? 'in':'out'}}}>{billSheet.thirdNo}</Link>
            </Descriptions.Item>
          )}

          {middleList.map((item, index) => (
            <Descriptions.Item key={index + item.key} label={item.title}>
              {item.formate
                ? item.formate(billSheet[item.key])
                : typeTextMap[item.key] || billSheet[item.key]}
            </Descriptions.Item>
          ))}
          {endBasicDescs.map((item, index) => (
            <Descriptions.Item key={index + item.key} label={item.title}>
              {typeTextMap[item.key] || billSheet[item.key]}
            </Descriptions.Item>
          ))}
        </Descriptions>
      )}
      <ProductListTable
        loading={loading}
        isLink={true}
        storeCode={storeId}
        otherColumns={
          isPurchaseReturnOut ? returnOtherColumns : orderOtherColumns
        }
        pageData={pageData}
        rowKey={record => record.id + record.skuId}
        getList={getList}
      />
      <p style={{ marginTop: '10px', textAlign: 'right', fontSize: 16 }}>
        共 <span style={colorStyle}>{billDetail.kindTotal}</span> 种商品，
        {typeText}数量 <span style={colorStyle}>{billDetail.stockTotal}</span>{' '}
        {typeTextMap.amountTitle}：
        <span style={colorStyle}>{billDetail.totalAmount}</span> 元
      </p>
    </Modal>
  )
}
